import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import reduxThunk from 'redux-thunk'
import { Provider } from 'react-redux'

import './styles/index.css'

import reducers from './reducers'
import Core from './core'

import registerServiceWorker from './registerServiceWorker'

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore)
const store = createStoreWithMiddleware(reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

ReactDOM.render(
  <Provider store={store}>
    <Core />
  </Provider>,
  document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js